export default function RaftDriftIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="10" fill="#6CCBF5" />
      <circle cx="51" cy="13" r="6" fill="#FFE27A" />
      <path d="M0 40q8-4 16 0t16 0 16 0 16 0v24H0Z" fill="#1E8FD6" />
      <path d="M31 12v26" stroke="#8A5A30" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M32.5 14q11 6 10 20H32.5Z" fill="#FFF8EC" />
      <path d="M32.5 24h10.2v3H32.5Z" fill="#FF6B5A" />
      <path d="M14 37h34l-3 6H17Z" fill="#C99353" />
      <path d="M20 37v6M27 37v6M34 37v6M41 37v6" stroke="#A87238" strokeWidth="1.2" />
      <path d="M2 54q6-9 12-7c2 1 3 4 2 6-3 1-5-1-6-2-2 2-5 3-8 3Z" fill="#6F7CE8" />
      <path d="M8 48l3-7 3 6Z" fill="#5B67D6" />
      <circle cx="13.5" cy="50" r="1.4" fill="#fff" />
      <path d="M46 49h10l-1 2H47Z" fill="#C78F52" />
      <path d="M0 50q8-3 16 0t16 0 16 0 16 0" stroke="#BFF4FF" strokeWidth="1.5" fill="none" opacity="0.7" />
    </svg>
  );
}
